import React, { Component } from 'react';
import { Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button } from 'reactstrap';
import {Link} from 'react-router-dom';
import { firebase } from '../../../firebase';
import RobotModal from "../modals/robotmodal";
class OneCard extends Component {

    state = {
        imageUrl:'',
        showRobotModal:null
    }

    findCardImageSrc = (imageSrc) => {
        firebase.storage().ref('roboImages').child(imageSrc).getDownloadURL().then((url)=>{
            this.setState({
                imageUrl:url
            });
        });
    }

    componentDidMount = () => {
        this.findCardImageSrc(this.props.imageSrc);
    }


    showRobotModal = (e) => {
        let robot_id = this.props.robot_id;
        this.setState({
            showRobotModal: robot_id
        });
    }

    toggleModal = () => {
        this.setState({
            showRobotModal: null
        });
    }

    render() {
        let {imageAlt, cardTitle, cardSubtitle, cardText, btnText, manufacturer} = this.props;
        return (
            <div>
                { (this.state.showRobotModal !== null) ?
                    <RobotModal robot_id={this.state.showRobotModal}
                                imgUrl={this.state.imageUrl}
                                details={cardText}
                                model={cardSubtitle}
                                manufacturer={manufacturer}
                                robotName={cardTitle}
                                toggleModal={this.toggleModal}/>
                 : null }
                <Card style={{marginBottom:'15px'}}>
                    <CardImg top
                             width="100%"
                             src={this.state.imageUrl ? this.state.imageUrl : 'http://via.placeholder.com/300x300'}
                             alt={imageAlt} />
                    <CardBody style={{height:'230px'}}>
                        <CardTitle>{cardTitle}</CardTitle>
                        <CardSubtitle><small>Model: </small>{cardSubtitle}</CardSubtitle>
                        <CardSubtitle><small>Made by: </small>{manufacturer}</CardSubtitle>
                        <CardText style={{minHeight:'80px', maxHeight:'80px'}}>{cardText.substring(0,64)}...</CardText>
                        <Button color="success" onClick={this.showRobotModal}>{btnText}</Button>{' '}
                        {
                            this.props.user ?
                            (<Link to={`/edit-bot/${this.props.robot_id}`}><Button color="warning">Edit</Button></Link>)
                            : null
                        }
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default OneCard;


// WEBPACK FOOTER //
// ./src/components/widgets/cards/onecard.js